// ConsultantShareLedgerModal.styles.js — 상담자배분 모양
//   2026-10-06 UX 6단계: 창(모달) → 마케터 1:1 관리의 세 번째 탭. 창 껍데기 모양은 지우고 패널 모양만 남김.
export const S = {
  panel: (compact = false) => ({
    padding: compact ? 0 : 16, display: 'flex', flexDirection: 'column', gap: 12, minWidth: 0, boxSizing: 'border-box',
  }),
  intro: { display: 'flex', flexDirection: 'column', gap: 4 },
  introTitle: { fontSize: 16, fontWeight: 900, color: 'var(--text)' },
  introText: { fontSize: 12, color: 'var(--text-muted)', lineHeight: 1.55 },
  summaryGrid: { display: 'grid', gridTemplateColumns: 'repeat(auto-fit,minmax(min(140px, 100%),1fr))', gap: 8, minWidth: 0 },
  metric: {
    border: '1px solid var(--border)',
    borderRadius: 10,
    padding: 10,
    background: 'var(--bg-subtle)',
    minWidth: 0,
  },
  metricLabel: { fontSize: 11, color: 'var(--text-muted)', fontWeight: 800 },
  metricValue: { marginTop: 4, fontSize: 16, color: 'var(--text)', fontWeight: 950 },
  toolbar: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 8, flexWrap: 'wrap', minWidth: 0 },
  search: {
    height: 40,
    width: 'min(360px, 100%)',
    flex: '1 1 240px',
    minWidth: 0,
    border: '1px solid var(--border)',
    borderRadius: 8,
    background: 'var(--bg-card)',
    color: 'var(--text)',
    padding: '0 10px',
    fontSize: 12,
  },
  reloadBtn: {
    height: 40,
    border: '1px solid var(--border)',
    borderRadius: 8,
    padding: '0 12px',
    background: 'var(--bg-card)',
    color: 'var(--text-sub)',
    fontSize: 12,
    fontWeight: 900,
    cursor: 'pointer',
    flexShrink: 0,
  },
  list: { display: 'flex', flexDirection: 'column', gap: 8 },
  row: (compact = false) => ({
    display: 'grid',
    gridTemplateColumns: compact
      ? 'minmax(0, 1fr)'
      : '82px minmax(180px,1.2fr) minmax(180px,1fr) minmax(170px,0.9fr) minmax(160px,0.8fr) minmax(190px,1fr)',
    gap: compact ? 10 : 8,
    alignItems: compact ? 'stretch' : 'center',
    border: '1px solid var(--border)',
    borderRadius: compact ? 12 : 10,
    padding: compact ? 12 : 10,
    background: 'var(--bg-card)',
    minWidth: 0,
    boxSizing: 'border-box',
  }),
  date: { fontSize: 12, fontWeight: 950, color: 'var(--text)', whiteSpace: 'nowrap' },
  main: { minWidth: 0 },
  store: { fontSize: 13, fontWeight: 950, color: 'var(--text)', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' },
  meta: { marginTop: 3, fontSize: 11, color: 'var(--text-muted)', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' },
  amount: { fontSize: 13, fontWeight: 950, color: '#be185d', textAlign: 'right', whiteSpace: 'nowrap' },
  calc: { fontSize: 11, color: 'var(--text-muted)', lineHeight: 1.45 },
  mobileTop: { display: 'flex', justifyContent: 'space-between', gap: 8, alignItems: 'center', minWidth: 0 },
  mobileStore: {
    fontSize: 15,
    fontWeight: 950,
    color: 'var(--text)',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  mobilePeopleGrid: { display: 'grid', gridTemplateColumns: 'repeat(2, minmax(0, 1fr))', gap: 8, minWidth: 0 },
  mobileInfoBox: {
    border: '1px solid var(--border)',
    borderRadius: 10,
    padding: '9px 10px',
    background: 'var(--bg-subtle)',
    minWidth: 0,
  },
  infoLabel: { fontSize: 10, fontWeight: 900, color: 'var(--text-muted)' },
  infoValue: { marginTop: 4, fontSize: 13, fontWeight: 950, color: 'var(--text)', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' },
  infoHint: { marginTop: 3, fontSize: 10, color: 'var(--text-muted)', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' },
  mobileAmountBox: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    gap: 10,
    borderRadius: 10,
    padding: '10px 11px',
    background: 'rgba(190,24,93,0.08)',
    border: '1px solid rgba(190,24,93,0.18)',
    minWidth: 0,
  },
  mobileCalc: { textAlign: 'right', fontSize: 10, color: 'var(--text-muted)', lineHeight: 1.5, minWidth: 0 },
  chip: (status) => ({
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    minWidth: 64,
    height: 24,
    borderRadius: 999,
    padding: '0 8px',
    background: status === 'excluded' ? 'rgba(100,116,139,0.14)' : 'rgba(22,163,74,0.13)',
    color: status === 'excluded' ? 'var(--text-muted)' : '#15803d',
    fontSize: 11,
    fontWeight: 950,
  }),
  memo: {
    width: '100%',
    minWidth: 0,
    height: 36,
    border: '1px solid var(--border)',
    borderRadius: 8,
    background: 'var(--bg-subtle)',
    color: 'var(--text)',
    padding: '0 8px',
    fontSize: 12,
    boxSizing: 'border-box',
  },
  actionRow: (compact = false) => ({
    display: 'flex',
    gap: compact ? 8 : 5,
    justifyContent: 'flex-end',
    marginTop: compact ? 0 : 6,
  }),
  actionBtn: (active, danger = false, compact = false) => ({
    height: compact ? 40 : 30,
    flex: compact ? '1 1 0' : '0 0 auto',
    border: active ? `1px solid ${danger ? '#dc2626' : '#15803d'}` : '1px solid var(--border)',
    borderRadius: 7,
    padding: compact ? '0 12px' : '0 8px',
    background: active ? (danger ? 'rgba(220,38,38,0.1)' : 'rgba(22,163,74,0.12)') : 'var(--bg-card)',
    color: active ? (danger ? '#dc2626' : '#15803d') : 'var(--text-muted)',
    fontSize: compact ? 12 : 11,
    fontWeight: 900,
    cursor: 'pointer',
  }),
  empty: { padding: 28, textAlign: 'center', color: 'var(--text-muted)', fontSize: 13 },
  error: {
    border: '1px solid rgba(220,38,38,0.25)',
    borderRadius: 10,
    padding: 10,
    background: 'rgba(220,38,38,0.08)',
    color: '#dc2626',
    fontSize: 12,
    fontWeight: 800,
  },
};
